import { useEffect } from "react";

let lastVh = -1;
let rafId = 0;

/** גובה אמיתי מעל המקלדת — בלי לעדכן בכל פריים (זה תוקע הקלדה במסופון) */
export function applyAppViewportHeight() {
  if (rafId) return;
  rafId = window.requestAnimationFrame(() => {
    rafId = 0;
    const h = Math.round(window.visualViewport?.height ?? window.innerHeight);
    if (h === lastVh) return;
    lastVh = h;
    document.documentElement.style.setProperty("--app-vh", `${h}px`);
  });
}

export function useAppViewportHeight() {
  useEffect(() => {
    applyAppViewportHeight();
    const vv = window.visualViewport;
    vv?.addEventListener("resize", applyAppViewportHeight);
    window.addEventListener("orientationchange", applyAppViewportHeight);
    window.addEventListener("resize", applyAppViewportHeight);
    return () => {
      vv?.removeEventListener("resize", applyAppViewportHeight);
      window.removeEventListener("orientationchange", applyAppViewportHeight);
      window.removeEventListener("resize", applyAppViewportHeight);
      if (rafId) window.cancelAnimationFrame(rafId);
      rafId = 0;
    };
  }, []);
}
